import get from 'lodash.get';

export const allOfObj = (array: any[], object: { [key: string]: any }) =>
  !array.some((value) => !get(object, value));
